import React, {
  useState,
  useEffect
} from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify'

import {
  useQuery,
  useMutation
} from '@apollo/client';
import { PaymentQueries } from '../../../helpers/GraphqlQueriesLib'
import { Button, RadioButton, LoaderBalls } from '../../genericComponents';
import { useSendEmail } from '../../hook/useSendEmail'

import BlueHero from '../../../assets/images/sprites/blueHero.jpg';

const inputFontStyle = `
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
`;

const LoaderContainer = styled.div`
width: 620px;
margin:1% auto;
`
const Container = styled.div`
  color:  ${props => props.theme.color.darkBlue};
  text-align:center;
  background-color: ${props => props.theme.color.white};
`;
const SelectButton = styled(Button)`
  margin:0 auto;
  display:block;
  min-width: 250px;
  height: 48px;
  background: ${props => props.theme.color.gabaYellow};
  color: ${props => props.theme.color.darkBlue};
  border-radius: 5px;
  bottom:1%;
  font-size:20px;
`

const CancelMessage = styled(SelectButton)`
  color: ${props => props.theme.color.darkBlue};
  min-width:160px;
  background: ${props => props.theme.color.softPurple};
  margin-bottom: 16px;
`

const ContentContainer = styled.div`
  text-align:left;
  display: flex;
  flex-direction: column;
  justify-content:space-between;
  max-width: 620px;
  margin:1% auto;
  padding: 30px 50px;
  .modal-video-body {
    margin-top: -300px;
  }
  background: ${props => props.theme.color.softYellow};
  margin-bottom: 30px;
`;

const ButtonContainer = styled(ContentContainer)`
  flex-direction: row;
  background: ${props => props.theme.color.transparent};
  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

const HeaderContainer = styled.div`
  background-image: url(${BlueHero});
  color: ${props => props.theme.color.white};
  padding: 15px 0;
`

const Title = styled.div`
  font-size: 24px;
  font-family: Gotham-Medium;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 38px;
  margin:1% auto;
`;

const Message = styled.div`
  width: 620px;
  margin:1% auto;
  font-size: 18px;
  font-family: Gotham-Medium;
  font-weight: 500;

`;

const FeedbackMessage = styled(Message)`
  text-align:center;
  width: auto;
`;

const Rectangle = styled.div`
  margin:0 auto;
  width: 620px;
  height: 2px;
  background:  ${props => props.theme.color.white};
`

const RadioButtonComponent = styled(RadioButton)`
  font-size:25px;
  margin: 5px 0;
`
const TextArea = styled.textarea`
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 10px 30px;
  padding-left: 10px;
  width: 90%;
  padding-top: 10px;
  ${inputFontStyle}
`;

const SurveyComponent = ({ cancelClick, user, logout }) => {

  const { loading: loadingSurvey,
    error,
    data: questions
  } = useQuery(
    PaymentQueries.GET_QUESTIONS)

  const [insertAnswer, { data: Answer, loading: insertLoading, }] = useMutation(
    PaymentQueries.INSERT_ANSWERS
  )

  const [optionsComponents, setOptionsComponents] = useState(null)
  const [selectedOption, setSelectedOption] = useState({ id: -1, text: "" })
  const [freeResponse, setFreeResponse] = useState(null)
  const [showFeedbackMessage, setShowFeedbackMessage] = useState(false)
  const [isFirstCall, setIsFirstCall] = useState(true)

  const [sendEmail, { isSending: isSendingEmail }] = useSendEmail('user_feedback_')

  const cancelHandler = ({ target }) => {
    cancelClick()
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedOption.id < 0) {
      toast.error("Please select an option")
    } else {
      const variables = {
        userEmail: user.email,
        id_option: selectedOption.id,
        free_response: freeResponse || ''
      }
      sendEmail({
        userEmail: user.email,
        userName: `${user.name} ${user.last_name}`,
        userOption: selectedOption.text,
        userComments: freeResponse || 'No additional comments'
      })
      insertAnswer({ variables })
      setShowFeedbackMessage(true)
    }
  }
  const changeHandler = ({ target }) => {
    if (target.type == "radio") {
      setSelectedOption({ id: target.value, text: target.parentElement.innerText })
    } else if (target.type == "textarea") {
      setFreeResponse(target.value)
    }
  }

  useEffect(() => {
    if (isFirstCall) {
      setIsFirstCall(false)
    } else {
      if (!isSendingEmail && !insertLoading) {
        toast.info("Thank you for your feedback!")
        setTimeout(logout, 2000)
      }
    }

  }, [isSendingEmail, insertLoading])

  useEffect(() => {
    if (questions) {
      let components = questions.question_by_pk.options.map((option, index) => {
        const { description, id } = option
        return (
          <RadioButtonContainer key={index} id={id}><RadioButtonComponent
            label={description}
            value={id}
            checked={selectedOption.id == id}
            onChange={changeHandler} /></RadioButtonContainer>)

      })
      components.push(<TextArea key={components.length} placeholder={"Tell us what's up..."} onChange={changeHandler} />)
      setOptionsComponents(components)
    }
  }, [questions, selectedOption])

  const selectStyle = ({ id }) => (id == selectedOption.id) ? 'bold' : 'normal';

  const RadioButtonContainer = styled.div`
    margin-bottom:10px;
    font-weight: ${selectStyle};
  `
  if (loadingSurvey)
    return <LoaderBalls />
  else
    return (<Container>
      <HeaderContainer>
        <Title>
          Nah, I don’t want to join GABA right now
    </Title>
        <Rectangle />
        <Message>
          Aw man! We’re sorry to hear that you don’t want to join GABA right now.<br />
          {loadingSurvey ? '...' : questions.question_by_pk.question}
        </Message>

      </HeaderContainer>
      {showFeedbackMessage ?
        (insertLoading || isSendingEmail) ? (<LoaderContainer><LoaderBalls /></LoaderContainer>) : (
          <ContentContainer>
            <FeedbackMessage>We’re sorry to see you go 😢<br />
          A team member will reach out to see how we can make GABA better for you in the future 😊</FeedbackMessage>
          </ContentContainer>) :
        (< form onSubmit={handleSubmit}>
          <ContentContainer>
            {optionsComponents}
          </ContentContainer>
          <ButtonContainer>
            <CancelMessage onSubmit={handleSubmit} disabled={insertLoading || (selectedOption < 0)} >Submit</CancelMessage>
            <SelectButton onClick={cancelHandler}>Actually, I will join GABA</SelectButton>
          </ButtonContainer>
        </form>)}
    </Container >);
};


export default SurveyComponent